import * as z from "zod";

export const getSkioIntegration = {
  name: "getSkioIntegration" as const,
  input: z.null(),
  output: z.object({ exists: z.boolean(), apiKey: z.string().optional() }),
};
